module.exports = __webpack_public_path__ + "static/img/home_culture_01.424f4b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/ter/images/home_culture_01.png
// module id = XwG3
// module chunks = 0